import Vue from 'vue'
import store from '@/store'

// window.onerror = function (msg, src, linenum, colnum, error) {
//   console.log(msg, src, linenum, colnum, error)
// }

Vue.config.errorHandler = async (err, vm, info) => {
  // 400 에러는 공통적으로 처리한다.
  try {
    console.error('에러!', err.message, err.data)
    console.error('에러!json', JSON.stringify(err))
  } catch (e) {}
  if (err?.status >= 400 && err.message) {
    console.log(err)
    await $swal.basic.error(err.message)
    return
  }
  if (err.name === 'NavigationDuplicated') {
    store.dispatch('time/refresh')
    return
  } else if (err.message && err.message.indexOf('via a navigation guard.') > -1) {
    return
  } else {
    store.dispatch('errors/add', { title: '정의되지 않은 에러 발생', message: err })
  }
}
